// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2vLyk","overflowing":"ReadFullNote_overflowing__3tUdn"};